// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3z2EL","row":"Node_row__2soCG","label":"Node_label__2QOot","footer":"Node_footer__2WzOi"};